export default "__VITE_ASSET__BU88Xmlc__"